import { SVGAttributes } from 'react';

import { Logo } from '../PaymentSystemLogo.ui';

import { mapComponentByName, PaymentSystemName } from './mapComponentByName';

type PaymentSystemLogoProps = SVGAttributes<SVGSVGElement>;

export const createLogoComponent = (name: PaymentSystemName) => {
  const LogoComponent = mapComponentByName[name];

  return (svgProps: PaymentSystemLogoProps) => {
    return <Logo {...svgProps} as={LogoComponent} />;
  };
};
